import React from "react";
import { makeStyles } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  Box: {
    padding: 20,
    border: "0.5px solid #828282",
    boxSizing: "borderBox",
    borderRadius: "5px",
    background: "#fff",
    marginTop: "20px",
    display: "flowRoot",
  },
  flexBox: {
    display: "flex",
    paddingTop: "20px",
    paddingBottom: "20px",
  },
  input: {
    height: "40px",
    width: "100%",
  },
  label: {
    fontWeight: 900,
  },
  cancelButton: {
    backgroundColor: "#E6ECEC",
    textTransform: "none",
    color: "#000",
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: "#E6ECEC" },
    },
  },
  addButton: {
    backgroundColor: "#1779CB",
    textTransform: "none",
    color: "#fff",
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: "#1779CB" },
    },
  },
}));

const AddNewPartModal = ({ modalOpen, setModalOpen }) => {
  const classes = useStyles();
  return (
    <>
      <Dialog
        open={modalOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ fontWeight: 900 }} id="alert-dialog-title">
          {"Add Part Type"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <div>
              <div className={classes.Box}>
                <div className={classes.flexBox}>
                  <div style={{ padding: 10 }}>
                    <label className={classes.label}>Part Terminology Id</label>
                    <input
                      type="text"
                      placeholder="Enter Part Terminology Id"
                      className={classes.input}
                    />
                  </div>
                  <div style={{ padding: 10 }}>
                    <label className={classes.label}>Part Type</label>
                    <input
                      type="text"
                      placeholder="Enter Part Type"
                      className={classes.input}
                    />
                  </div>
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setModalOpen(false)}
            color="primary"
            autoFocus
            className={classes.cancelButton}
          >
            Cancel
          </Button>
          <Button
            onClick={() => setModalOpen(false)}
            color="primary"
            autoFocus
            className={classes.addButton}
          >
            Add Part Type
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddNewPartModal;
